<template>
  <dv-border-box-9>
    <div style="width: 600px; height: 454px">
      <div class="tab_div">
        <div
          v-for="(item, index) in produceList"
          @click="tabClick(index)"
          :class="selectedIndex == index ? 'c-active' : ''"
        >
          {{ item.name }}
        </div>
      </div>
      <div class="chart_pic" v-show="chartShow">
        <div class="left-title">
          测
          <br />量 <br />值
        </div>
        <div class="data-chart" ref="clPic"></div>
      </div>
    </div>
  </dv-border-box-9>
</template>

<script>
import { getAction } from '@/api/manage'
import moment from 'moment'
export default {
  name: 'DeviceDataChart',
  data() {
    return {
      url: {
        sbAndMk: '/show/bigScreen/getSbAndMkByMonth',
        // 设备列表
        deviceList: '/device/device/list',
        // 查询设备数据列表
        deviceDataList: '/show/dataMeasureNormal/listChart',
        // 雨量设备数据接口
        rainDeviceDataList: '/device/dataRain/listChart',
        // GNSS设备数据接口
        gnssDeviceDataList: '/device/dataGns/listChart',
      },
      projectId: null,
      data1: [],
      clPic: null,
      // 是否显示图表
      chartShow: false,
      // 设备类型
      deviceTypeMap: null,
      // 选中的产品
      selectProduce: null,
      // 产品列表
      produceList: [],
      // 选中的tab下标
      selectedIndex: 1,
      // GNSS产品id
      gnssProduceId: 85,
      // 雨量产品id
      rainProduceId: 77,
    }
  },
  async mounted() {},
  methods: {
    // 重新加载数据
    reloadData(projectId) {
      this.chartShow = false
      this.projectId = projectId
      this.selectedIndex = 0
      this.deviceTypeMap = new Map()
      this.produceList = []
      this.loadData(this.selectedIndex)
    },
    async loadData(index) {
      if (!this.projectId) {
        return
      }
      this.clPic = this.$echarts.init(this.$refs.clPic)
      const devices = await this.getDeviceList()
      if (devices.result.records || devices.result.records.length > 0) {
        for (let i = 0; i < devices.result.records.length; i++) {
          const item = devices.result.records[i]
          if (this.deviceTypeMap.has(item.produceId)) {
            // 该产品已存在
            this.deviceTypeMap.get(item.produceId).push(item)
          } else {
            // 产品不存在
            let data = []
            data.push(item)
            this.deviceTypeMap.set(item.produceId, data)
            this.produceList.push({
              id: item.produceId,
              name: item.produceName,
            })
          }
        }
        this.tabChange(index)
      }
    },
    // 查询后的数据 tab切换使用缓存
    tabChange(index) {
      // 取出设备编号最多两个 用逗号隔开
      let sidNos = ''
      let produceId = ''
      // 该项目存在产品 取第一个产品
      if (this.produceList && this.produceList.length > 0) {
        produceId = this.produceList[index].id
        // 取出该产品所有设备
        let deviceList = this.deviceTypeMap.get(produceId)
        // 最多取几个设备 gnss类型最多取一个
        let max = 2
        if (produceId == this.gnssProduceId) {
          max = 1
        }
        for (let i = 0; i < deviceList.length; i++) {
          if (i < max) {
            // 最多取max个
            sidNos += deviceList[i].sidNo + ','
          }
        }
      }

      if (sidNos && sidNos.length > 0) {
        sidNos = sidNos.substring(0, sidNos.length - 1)
        this.getDeviceDataList(sidNos, produceId)
      }
    },
    /**
     * @description: 获取服务数据
     * @param {undefined}
     * @return {Promise}
     */
    async getSbAndMkByMonth() {
      return await getAction(this.url.sbAndMk)
    },
    // 获取设备
    async getDeviceList(ids) {
      return await getAction(this.url.deviceList + '?projectId=' + this.projectId)
    },
    // 获取设备数据
    getDeviceDataList(ids, produceId) {
      // let params = Object.assign({}, this.queryParam)
      // queryParam: { zlxs: ['value17_18'], ds: '1', dtBegin: moment(new Date()).add(-7, 'days') },
      // params.sidNos = ids
      // params.projectId = this.projectId
      let url = this.dispatchUrl(ids, produceId)

      getAction(url).then((res) => {
        if (res.success) {
          if (!res.result) {
            // this.$message.warning('没有查询到数据！')
            this.chartShow = false
            return
          }
          this.chartShow = true
          this.clPic.getDom().style.height = '340px'
          this.clPic.resize()
          this.data1 = res.result.allData
          let sidMapCl = new Map()
          let mySids = []
          let myDts = []
          let dataCl = []
          this.data1.forEach((v) => {
            if (v.sidName && !v.sbName) {
              v.sbName = v.sidName
            }
            myDts.push(v.dt)
            if (produceId == this.gnssProduceId) {
              // GNSS类型
              let curCl1 = [v.dt, v.value15_16]
              let curCl2 = [v.dt, v.value17_18]
              let curCl3 = [v.dt, v.value19_20]
              if (!mySids || mySids.length == 0) {
                mySids.push('北方向位移')
                mySids.push('东方向位移')
                mySids.push('垂直方向位移')
                let tempCl1 = []
                tempCl1.push(curCl1)
                sidMapCl.set(mySids[0], tempCl1)
                dataCl.push({ name: mySids[0], type: 'line', connectNulls: true, smooth: true, data: tempCl1 })
                let tempCl2 = []
                tempCl2.push(curCl2)
                sidMapCl.set(mySids[1], tempCl2)
                dataCl.push({ name: mySids[1], type: 'line', connectNulls: true, smooth: true, data: tempCl2 })
                let tempCl3 = []
                tempCl3.push(curCl3)
                sidMapCl.set(mySids[2], tempCl3)
                dataCl.push({ name: mySids[2], type: 'line', connectNulls: true, smooth: true, data: tempCl3 })
              } else {
                sidMapCl.get(mySids[0]).push(curCl1)
                sidMapCl.get(mySids[1]).push(curCl2)
                sidMapCl.get(mySids[2]).push(curCl3)
              }
            } else {
              let curCl = [v.dt, v.value17_18]
              if (sidMapCl.has(v.sbName)) {
                sidMapCl.get(v.sbName).push(curCl)
              } else {
                let tempCl = []
                tempCl.push(curCl)
                sidMapCl.set(v.sbName, tempCl)
                dataCl.push({ name: v.sbName, type: 'line', connectNulls: true, smooth: true, data: tempCl })
                mySids.push(v.sbName)
              }
            }
          })
          let mySeries = dataCl
          // 指定图表的配置项和数据
          var option = {
            color: ['#6ED7B3', '#1751C3', '#CCA85B'],
            tooltip: {
              trigger: 'axis',
            },
            legend: {
              data: mySids,
              left: 'center',
              top: 'bottom',
              textStyle: {
                color: '#60648e',
              },
            },
            grid: {
              left: '3%',
              right: '4%',
              bottom: '7%',
              containLabel: true,
            },
            xAxis: {
              type: 'category',
              data: myDts,
              axisLine: {
                show: false,
              },
              axisTick: {
                show: false,
              },
              axisLabel: {
                color: '#60648e',
              },
            },
            yAxis: {
              type: 'value',
              scale: true,
              axisLine: {
                show: false,
              },
              axisTick: {
                show: false,
              },
              splitLine: {
                lineStyle: {
                  color: '#5D649E',
                },
              },
              axisLabel: {
                color: '#60648e',
              },
            },
            series: mySeries,
          }
          // 使用刚指定的配置项和数据显示图表。
          this.clPic.setOption(option, true)
        } else {
          // this.$message.warning('没有查询到数据！')
          this.chartShow = false
        }
      })
    },
    // 适配接口 雨量和GNSS特殊处理
    dispatchUrl(ids, produceId) {
      let url = ''
      let params =
        '?dtBegin=' +
        moment(new Date()).add(-7, 'days').format('YYYY-MM-DD HH:mm:ss') +
        '&sidNos=' +
        ids +
        '&projectId=' +
        this.projectId +
        '&ds='
      if (produceId == this.rainProduceId) {
        // 雨量
        url = this.url.rainDeviceDataList + params + '0' + '&value17_18'
      } else if (produceId == this.gnssProduceId) {
        // GNSS
        url = this.url.gnssDeviceDataList + params + '0' + '&zlxs=value15_16,value17_18,value19_20' + '&sids=' + ids
      } else {
        // 其他
        url = this.url.deviceDataList + params + '1' + '&zlxs=value17_18'
      }
      return url
    },
    // 数组中是否存在某个值
    isExistForList(list, val) {
      for (let i = 0; i < list.length; i++) {
        if (list[i] == val) {
          return true
        }
      }
      return false
    },
    // 切换tab
    tabClick(index) {
      if (this.selectedIndex == index) {
        return
      }
      this.selectedIndex = index
      this.tabChange(index)
    },
  },
}
</script>
<style lang='less' scoped>
.title {
  text-align: center;
  margin: 0;
  // margin-bottom: 24px;
  padding-top: 18px;
  color: #96bbda;
  font-size: 24px;
  font-weight: 500;
}
.border-box-content {
  padding: 24px;
}

.chart_pic {
  display: flex;
  padding: 0px 20px;
  // position: relative;
  margin-top: 16px;
  .data-chart {
    width: 540px;
  }
  .left-title {
    padding: 8px;
    display: flex;
    align-items: center;
    color: #ccc;
    font-weight: 700;
  }
}
.tab_div {
  display: flex;
  align-items: flex-end;
  flex-direction: row;
  height: 50px;
  margin-left: 40px;
  div {
    font-size: 13px;
    color: #929292;
    cursor: pointer;
    font-weight: 100;
    position: relative;
  }
  div + div {
    margin-left: 15px;
    &::before {
      content: '';
      display: block;
      width: 2px;
      height: 14px;
      background: #666666;
      position: absolute;
      left: -9px;
      top: 4px;
    }
  }
}
.c-active {
  /* top: -1px; */
  color: #3b90e6 !important;
  font-weight: 700 !important;
}
</style>
